import { render, staticRenderFns } from "./frequency-selector.vue?vue&type=template&id=43cf36ec&"
import script from "./frequency-selector.vue?vue&type=script&lang=js&"
export * from "./frequency-selector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports